import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { MyReportsStateClass } from "../interfaces/ReportClasses"; 
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";


const initialState: MyReportsStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    myReportsList: []
}

interface IThunkApi {
    state: {
        myReports: MyReportsStateClass
    }
}

export const getMyReportsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Reports/v2/getMyReports",
        async (arg, thunkApi) => {
            console.log('response', arg)
            const response = await fetchAPI("api/v2/Reports/MyReports/", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
export const CopyReportByReportIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/CopyReportByReportId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Reports/CopyReport/" + arg, "POST", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const deleteAccountReportAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/deleteAccountReport",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Reports/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

const myReportsSlice = createSlice({
    name: "customReportView",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMyReportsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getMyReportsAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.employeeTypeList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.myReportsList = [];
                } else {
                    state.myReportsList = payload.Data;
                    state.myReportsList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};

            })
            .addCase(getMyReportsAsync.rejected, (state) => {
                state.status = 'failed';
            })
            

            .addCase(CopyReportByReportIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(CopyReportByReportIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(CopyReportByReportIdAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(deleteAccountReportAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountReportAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountReportAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const { resetSelectedRecordObjectInState} = myReportsSlice.actions
export const MyReportsState = (state: RootState) => state.myReports
export default myReportsSlice.reducer


